import { isEmpty, get } from 'lodash';

import DefaultDialogController from 'utils/notifications/default-dialog-controller';

const MAX_NAME_LENGTH = 255;

const mapStateToThis = ({ session, config, ui }) => {
  const { locale } = session;
  const { locales } = config;
  const { selectedLanguage } = ui;

  return {
    locale,
    locales,
    selectedLanguage,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', 'appFactory', '$timeout', 'Notifications')
class CategoryController extends DefaultDialogController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onInit() {
    this.$timeout(() => {
      this.api.initializeForm.run(this.namespace, this.moduleName, this.form, get(this, 'category.documentTypeId'));
    });
    this.maxNameLength = MAX_NAME_LENGTH;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  submit() {
    this.form.$setSubmitted();
    const hasEmptyTranslation = this.locales.some(
      (locale) => isEmpty(this.category.translations[locale.code]) || isEmpty(this.category.translations[locale.code].name)
    );

    if (hasEmptyTranslation && this.locales.length > 1) {
      this.Notifications.alertWarning(this.gettextCatalog.getString('Enter other language before submitting.'));
    } else if (!hasEmptyTranslation) {
      this.confirm(this.category);
    }
  }
}

export default CategoryController;



// WEBPACK FOOTER //
// ./src/modules/documents/components/documents-management/category-dialog/category-dialog-controller.js